import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppButton = () => {
  const phoneNumber = "+919870263399"; 

  return (
    <a
      href={`https://wa.me/${phoneNumber}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-4 right-4 z-50 bg-[#31C48D] text-white p-2 rounded-full shadow-lg flex items-center justify-center hover:bg-green-600 transition duration-300"
    >
      <FaWhatsapp size={44} />
    </a>
  );
};

export default WhatsAppButton; 
